

























































































import Vue from 'vue'
import { mapGetters } from 'vuex'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import MapView from '../mapview/Map.vue'
import LeafletMapView from '../mapview/LeafletMap.vue'
import Node from '@/models/Node'
import Vector2 from '../../models/Vector2'
import ImageInput from '@/components/ImageInput.vue'
import Project from '@/models/Project'
import BTextareaLimited from '@/components/input_limited/BTextareaLimited.vue';
import BFormInputLimited from '@/components/input_limited/BFormInputLimited.vue';
import PlanSelector from '@/components/payment/PlanSelector.vue';
import SubscriptionPlan from '../../models/payment/SubscriptionPlan'

@Component({
	components:
	{
		MapView,
		ImageInput,
		LeafletMapView,
		BTextareaLimited,
		BFormInputLimited,
		PlanSelector
	},
    computed: 
	{
		...mapGetters([
			'projects'
		])
	},
	watch: 
	{
		"projectData.type": function (cur:string, old:string)
		{
			let tg = this as any;
			let data = tg.projectData;
			if (data.background_image)
			{
				delete data.background_image;
			}
			if (data.coords)
			{
				delete data.coords;
			}
			if (data.caption)
			{
				delete data.caption;
			}

			// Clear it if we're not moving between default/image
			if (!((old == 'default' && cur == 'image') || (old == 'image' && cur == 'default')))
			{
				tg.mapNodes.length = 0;
				this.$set(this, 'selectedMapPin', null);
			}

			if (cur == 'image')
			{
				this.$set(data, 'background_image', '');
			}
			if (cur == 'map')
			{
				this.$set(data, 'coords', { latitude : 0, longitude : 0, zoom_level : 1 });
			}
			if (cur != 'none')
			{
				this.$set(data, 'caption', '');
			}
			this.$set(this, 'projectData', data);
		}
	}
})

export default class CreateProject extends Vue
{
	@Prop(Object) readonly modal! : Object;

	loading = false;
	plans : SubscriptionPlan[] = [];
	planSelected = false;

	get projectsLength()
	{
		return (this as any).projects.size;
	}

	async copyProject(project : Project)
	{
		this.loading = true;
		this.projectName = `${project.name} [Copy]`;
		// enforce length limit
		if (this.projectName.length > 128)
		{
			this.projectName = `${this.projectName.substr(0, 118)}... [Copy]`;
		}
		this.projectDescription = project.description;
		
		let pdata = JSON.parse(project.data);
		this.projectData.type = pdata.type;
		this.$nextTick(() =>
		{
			this.$set(this, 'projectData', pdata);
		});

		this.mapNodes.length = 0;
		try
		{
			let resp = await this.$http.get(`projects/mapdata?projectid=${project.id}`);
			let pins = resp.data.mapdata as any[];
			for (let i = 0; i < pins.length; ++i)
			{
				let cur = pins[i];
				let n = new Node;
				n.name = cur.title;
				this.$set(n, 'position', new Vector2(cur.x, cur.y));
				this.mapNodes.push([i, n]);
			}
		}
		catch (ex)
		{
			alert(`Unable to load map pins: ${ex.response.error}`);
		}
		this.loading = false;		
	}

	get oneProjectLimit() : boolean
	{
		return (!this.user.isSubscribed && !this.user.trialing && (<{projects: Map<string, Project>}><unknown>this).projects.size > 0);
	}

	async mounted()
	{
		this.loading = true;
        try
        {
            let resp = await this.$http.get<{plans : SubscriptionPlan[]}>('payments/subscription/plans');
            let ps = resp.data.plans;
            this.plans.length = 0;
            for (let p of ps)
            {
                const plan = Object.assign(new SubscriptionPlan(), p);
                if (plan.id.startsWith('project'))
                {
                    this.plans.push(plan); // project plans
                }
            }
            this.plans.sort((a, b) => a.billingCycle - b.billingCycle);
        }
        catch (er)
        {
            console.error(er);
        }
		this.loading = false;
	}

	get isInputValid() : boolean
	{
		if (this.oneProjectLimit && !(this.planSelected)) return false;
		if (this.projectName.trim() == '') return false;
		if (this.projectDescription.trim() == '') return false;
		if (this.projectData.type == 'image')
		{
			if ((this.projectData as any).background_image == '') return false;
			if (!this.$refs.imageInputComponent) return false;
			if (!(this.$refs.imageInputComponent as any).imageURLValid) return false;
		}
		return true;
	}

	mapOptions = [
		{value: 'default', text: 'Default World Map'},
		{value: 'image', text: 'Image (URL)'},
		{value: 'map', text: 'Map'},
		{value: 'none', text: 'None'}
	];
	
	emptyString = '';
	projectData = {type: 'default'};
	projectName = "";
	projectDescription = "";
	get projectMapNodes()
	{
		let arr : Object[] = [];
		for (let i = 0; i < this.mapNodes.length; ++i)
		{
			let node = (this.mapNodes as any)[i][1] as Node;
			arr.push({name: node.name, xCoord: node.position.x, yCoord: node.position.y});
		}
		return {nodes: arr};
	}

	mapNodes : Object[] = []
	selectedMapPin: Node = <any>null;

	imgMapClicked(x : number, y : number)
	{
		let vec = new Vector2(x, this.projectData.type == 'map' ? y : 1-y);
		if (this.selectedMapPin)
		{
			this.$set(this.selectedMapPin, 'position', vec);
		}
		else
		{
			let n = new Node();
			n.position = vec
			n.name = "New Map Pin"
			
			// This is weird bc of the way that the getter works
			this.mapNodes.push([this.mapNodes.length, n]);
			this.$set(this, 'selectedMapPin', n);
		}
	}

	imgNodeClicked(node : Node)
	{
		this.$set(this, 'selectedMapPin', node);
	}
	
	gooMapCenterChange(center : any)
	{
		console.log(`${center.lat}, ${center.lng}`);
		(this.projectData as any).coords.latitude = center.lat;
		(this.projectData as any).coords.longitude = center.lng;
	}

	gooMapZoomChange(zoom : any)
	{
		(this.projectData as any).coords.zoom_level = zoom;
	}

	deleteSelectedNode()
	{
		if (!this.selectedMapPin)
		{
			return;
		}

		for(let i = 0; i < this.mapNodes.length; ++i)
		{
			let cur = (this.mapNodes as any)[i][1];
			if (cur == this.selectedMapPin)
			{
				this.mapNodes.splice(i, 1);
				break;
			}
		}
		this.$set(this, 'selectedMapPin', null)
	}

	saveSelectedNode()
	{
		this.$set(this, 'selectedMapPin', null)
	}
}
